export default __webpack_public_path__ + "static/media/khruangbin.d56d2515.jpeg";